import React, { createContext, Dispatch, SetStateAction } from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import StateProvider from '../../../providers/default/StateProvider'
import EmperorAgentSearchForm from '../../../components/admin/EmperorAgentSearchForm'
import AccountAgentWalletCreateForm from '../../../components/admin/account/AccountAgentWalletCreateForm'

const RequestContext = createContext<[
  string,
  Dispatch<SetStateAction<string>>
]>(['', () => {}])

const AccountAgentWalletCreateTopUpDeductPage: React.FC = () => {
  return (
    <StateProvider context={RequestContext} defaultValue={''}>
      <Box padding={5}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <EmperorAgentSearchForm context={RequestContext} />
          </Grid>
          <Grid item>
            <AccountAgentWalletCreateForm
              requestContext={RequestContext}
            />
          </Grid>
        </Grid>
      </Box>
    </StateProvider>
  )
}

export default React.memo(AccountAgentWalletCreateTopUpDeductPage)
